import React from 'react';
import Header   from '../components/Header';
import Hero     from '../components/Hero';
import About    from '../components/About';
import Services from '../components/Services';
import CTA      from '../components/CTA';
import Footer   from '../components/Footer';

const HomePage = () => (
  <div className="min-h-screen">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <CTA />
    </main>
    <Footer />
  </div>
);

export default HomePage;

